const refresh_token = (state = null, action) => {
	switch (action?.type) {
		case "SET_REFRESH_TOKEN":
			return action.refresh_token;
		default:
			return state;
	}
};
export default refresh_token;
